import api from './api';

export const surveyService = {
    async getSurveys(params = {}) {
        const response = await api.get('/survey', { params });
        return response.data;
    },

    async getSurveyById(surveyId) {
        const response = await api.get(`/survey/${surveyId}`);
        return response.data;
    },

    async createSurvey(data) {
        const response = await api.post('/survey', data);
        return response.data;
    },

    async updateSurvey(surveyId, updates) {
        const response = await api.put(`/survey/${surveyId}`, updates);
        return response.data;
    },

    async submitResponse(surveyId, data) {
        const response = await api.post(`/survey/${surveyId}/respond`, data);
        return response.data;
    },

    async getSurveyResults(surveyId) {
        const response = await api.get(`/survey/${surveyId}/results`);
        return response.data;
    },

    async deleteSurvey(surveyId) {
        const response = await api.delete(`/survey/${surveyId}`);
        return response.data;
    },

    async exportResults(surveyId) {
        const response = await api.get(`/survey/${surveyId}/export`, {
            responseType: 'blob',
        });
        return response.data;
    },
};

export default surveyService;
